//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		label: String,
		phone: String,
		text: String,
	},
	computed: {
		_phone() {
			return this.phone.replace(/\D/g, "")
		},
		_text() {
			return window.encodeURIComponent(this.text).replace("%5Cn", '%0a')
		}
	}
}
